import React from 'react'; import ExtendedModulePage from './ExtendedModulePage'; export default function MarkSheetsPage(){return <ExtendedModulePage moduleKey="mark-sheets"/>}
